import type { ISocial } from "../../../../types/models/social.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  socials: Array<ISocial>;
}

export function useSearchSocialsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/socials/search",
  });
}
